import { getCountries, getCountryCallingCode } from "react-phone-number-input/input";

/**
 * Zwraca pełny numer telefonu z prefiksem kraju
 */
export const getFullPhoneNumber = (countryCode, phoneNumber) => {
  if (!countryCode || !phoneNumber || countryCode.length !== 2) return phoneNumber;

  try {
    const prefix = getCountryCallingCode(countryCode);
    return `+${prefix}${phoneNumber}`;
  } catch (error) {
    console.warn("Invalid countryCode in getFullPhoneNumber:", countryCode, error);
    return phoneNumber;
  }
};

/**
 * Zwraca listę krajów posortowaną alfabetycznie wg danego języka
 */
export const getSortedCountries = (labels = {}, language) => {

  if (!language) {
    throw new Error("getSortedCountries: language is required");
  }
  
  const locale = language;

  return getCountries().sort((a, b) => {
    const labelA = labels[a] || a;
    const labelB = labels[b] || b;
    return labelA.localeCompare(labelB, locale);
  });
};
